import { useCallback, useMemo } from 'react';
import { useShellRootContext } from '../contexts/ShellRoot';
import { useGetTenantId } from 'src/hooks/useGetTenantId';

export const useIsOAuthToken = () => {
  const { getTenantId } = useGetTenantId();

  const {
    interfaces: { v1, v2 }
  } = useShellRootContext();

  const { authProvider: shellAuthProvider, tenantHandlerInterface } = v1;

  const {
    authProvider: { createOrglessAuthProvider }
  } = v2;

  const authProvider = useMemo(
    () => ({
      ...shellAuthProvider,
      onTokenExchangeRequired: async (props) => {
        const accountId = props?.accountId || '';

        if (accountId) {
          if (accountId !== getTenantId()) {
            await tenantHandlerInterface.setTenant({
              tenantId: accountId,
              authContext: 'tenant',
              preventReload: true
            });
          }
        }
      },
      getOrglessAccessToken: async (requireRefresh) => {
        if (requireRefresh) {
          await shellAuthProvider.getAccessToken(true);
        }

        const orgLessAuthProvider = await createOrglessAuthProvider();
        return await orgLessAuthProvider.getAccessToken();
      }
    }),
    [
      createOrglessAuthProvider,
      getTenantId,
      shellAuthProvider,
      tenantHandlerInterface
    ]
  );

  const isOAuthToken = useCallback(async () => {
    const jwtPayload = await authProvider.getDecodedUserStratusJWTPayload();
    return !!jwtPayload?.iss?.includes('oauth-auth');
  }, [authProvider]);

  return isOAuthToken;
};

export default useIsOAuthToken;
